import React, { useState, useEffect } from "react";
import { makeRequestAuth } from "../../_config/api";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import { IoCloseCircleOutline } from "react-icons/io5";
import { FiSave } from "react-icons/fi";

const UpdateAppSettingModal = ({
  isOpen,
  onClose,
  fetchSettings,
  initialData,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    key: "",
    value: "",
  });

  // Populate Form Data
  useEffect(() => {
    if (initialData && isOpen) {
      setFormData({
        id: initialData._id || "",
        name: initialData.name || "",
        key: initialData.key || "",
        value: initialData.value || "",
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) return showErrorToast("Name is required");

    try {
      setIsSubmitting(true);
      const response = await makeRequestAuth(
        "post",
        "/appSetting/updateAppSetting",
        formData,
      );

      if (response.error || response.status === false) {
        showErrorToast(response.message || "Failed to update setting");
        setIsSubmitting(false);
        return;
      }

      showSuccessToast(response.message || "Setting updated successfully");

      // 800ms ka timeout yahan set kiya gaya hai
      setTimeout(() => {
        fetchSettings();
        onClose();
        setIsSubmitting(false);
      }, 800);
    } catch (error) {
      console.error("Error updating:", error);
      showErrorToast(error.message || "Failed to update setting");
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="bg-white dark:bg-[#1E2738] rounded-2xl shadow-2xl w-full max-w-xl flex flex-col border border-purple-300 dark:border-purple-600/50 animate-fadeIn">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 rounded-t-2xl">
          <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            Edit App Setting
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition"
          >
            <IoCloseCircleOutline size={28} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition"
              readOnly // Name is unique and usually shouldn't be edited easily, but remove readOnly if needed
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Key
            </label>
            <input
              type="text"
              name="key"
              value={formData.key}
              onChange={handleChange}
              placeholder="e.g. API_KEY"
              className="w-full px-4 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Value
            </label>
            <textarea
              name="value"
              rows={3}
              value={formData.value}
              onChange={handleChange}
              placeholder="Enter value"
              className="w-full px-4 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 rounded-b-2xl flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2.5 rounded-xl text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 font-medium transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 hover:scale-[1.02] text-white font-semibold shadow-lg transition disabled:opacity-50"
          >
            {isSubmitting ? (
              "Saving..."
            ) : (
              <>
                <FiSave /> Update Setting
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateAppSettingModal;
